import React from "react";
import CryptoJS from "crypto-js";
import './CustomPlans.css';
import { MyContext } from "../../App";

const CustomPlans = ({AppName}) => {

  const SiteName = React.useContext(MyContext);

  React.useEffect(() => {
    getData(); 
  }, []);

  async function getData() {
    try {
      const response = await fetch(
        "https://apps365plans.azurewebsites.net/api/plans"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const item = await response.json();
      let plans = item?.data?.value?.find((c) => c.ProductName === AppName);
      if (!plans) {
        console.error("No plans found for this app.");
        return;
      }
      let UserBased = plans?.Data
        ? JSON.parse(plans?.Data)?.UserBased || "No"
        : "No";
      let parsedData = parseAndCombinePlans(plans);
      console.log(parsedData, "current plans");

      // Get container div
      const container = document.getElementById("pricing-widget-container");
      container.innerHTML = ""; // Clear previous content

      const validData = parsedData.filter(
        (item) =>
          item.price !== undefined &&
          item.subPrice !== undefined &&
          item.TotalPrice !== undefined &&
          Array.isArray(item.plans) &&
          item.plans.length > 0 &&
          item.plans.some((plan) => plan.trim() !== "")
      );

      // Generate and append the HTML
      container.innerHTML = `
          <div class="pricing-widget-container">
              ${validData
                ?.map(
                  (plan, index) => `
                      <div class="plan-card ${
                        index === validData.length - 1 ? "featured" : ""
                      }">
                          <h4 class="plan-title">${plan.title}</h4>
                          <div class="plan-price">
                              ${
                                plan.price == 0
                                  ? `<div>Free</div>
                              `
                                  : `
                              <div>$${plan.price}</div>
                              <div class="SubPriceUI">${plan.subPrice}</div>`
                              }
                             
                          </div>
                          <p class="billing-info" style="visibilty: ${plan.price == 0 ? "hidden" : "visible"}">${
                            UserBased == "Yes"
                              ? `per user / month, billed yearly`
                              : `per month, billed yearly`
                          }</p>
                          <h3 class="plan-features-title">Everything in ${
                            index > 0 ? validData[index - 1].title : "Standard"
                          } and...</h3>
                          <ul class="plan-features">
                              ${plan.plans
                                .map((feature) => (feature ? `<li><span className="tick-icon">✔ </span><span>${feature}</span></li>` : ""))
                                .join("")}
                          </ul>
                          <div class="custom-elementor-shortcode">
                              <button class="buy-price  ${
                                index === validData.length - 1
                                  ? "CustomAddToCartEnterprise"
                                  : "CustomAddToCart"
                              }" id="std${index + 1}" 
                                  data-ids="${3154 + index}">
                                  <a href="#!" id="std${
                                    index + 1
                                  }1">Add To Cart</a>
                              </button>
                          </div>
                      </div>
                  `
                )
                .join("")}
          </div>
      `;

      // Attach event listeners dynamically
      validData.forEach((plan, index) => {
        const addToCartButton = document.getElementById(`std${index + 1}`);
        if (addToCartButton) {
          addToCartButton.addEventListener("click", () => getTxID(plan)); // Pass the plan object directly
        }
      });
    } catch {}
  }

  function parseAndCombinePlans(data) {
    return [
      { title: "Standard", ...JSON.parse(data.P1Plans) },
      { title: "Plus", ...JSON.parse(data.P2Plans) },
      { title: "Premium", ...JSON.parse(data.P3Plans) },
      { title: "Enterprise", ...JSON.parse(data.P4Plans) },
    ];
  }
  function decryptFromBase64Url(encryptedText) {
    let secretKey = "Super@Salt";
    let base64 = encryptedText.replace(/-/g, "+").replace(/_/g, "/"); // Convert back to standard Base64
    let decrypted = CryptoJS.AES.decrypt(atob(base64), secretKey);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  function encryptToBase64Url(text) {
    let secretKey = "Super@Salt";
    let encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
    let base64 = btoa(encrypted); // Convert to Base64
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); // Make it URL-safe
  }

  // Function to launch Paddle Checkout with transactionId
  let TTID = "";

  function createProductItem(img, name, description, price) {
    return {
      price: {
        description: description || "",
        billing_cycle: {
          frequency: 1,
          interval: "year",
        },
        tax_mode: "external",
        unit_price: {
          amount: (Number(price) * 100).toString(),
          currency_code: "USD",
        },
        custom_data: {
          selectedYear: "1 year",
        },
        product: {
          name: name || "",
          image_url: img || "",
          tax_category: "saas",
        },
      },
      quantity: 1,
    };
  }

  function isStringValidated(value) {
    if (
      typeof value !== "string" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return false;
    } else {
      return true;
    }
  }

  function filterUniqueProducts(cartItems) {
    const uniqueProducts = [];
    const seenDescriptions = new Set();

    cartItems?.forEach((item) => {
      const description = item.price.description;
      if (!seenDescriptions.has(description)) {
        uniqueProducts.push(item);
        seenDescriptions.add(description);
      }
    });

    return uniqueProducts;
  }

  async function getTxID(plan) {
    console.log("Getting transaction ID...", plan);

    let staticbody = {
      items:
        isStringValidated(plan?.AddOns?.[0]?.name) &&
        plan?.AddOns?.[0]?.price &&
        plan?.AddOns?.[0]?.price != 0
          ? [
              createProductItem(
                plan?.ProductImage,
                plan?.ProductTitle,
                plan?.ProductDescription,
                plan?.TotalPrice
              ),
              ...plan?.AddOns?.map((addOn) =>
                createProductItem(
                  plan?.ProductImage,
                  addOn?.name,
                  addOn?.description,
                  addOn?.price
                )
              ),
            ]
          : [
              createProductItem(
                plan?.ProductImage,
                plan?.ProductTitle,
                plan?.ProductDescription,
                plan?.TotalPrice
              ),
            ],
    };

    let Existingcart = localStorage.getItem("storedUpdatedAppURL")
      ? JSON.parse(
          decryptFromBase64Url(localStorage.getItem("storedUpdatedAppURL"))
        )
      : [];
    let currency_code = Existingcart
      ? Existingcart?.currency_code || "USD"
      : "USD";

    let currency_symbol = Existingcart
      ? Existingcart?.currency_symbol || "$"
      : "$";

    let userInfo = Existingcart ? Existingcart?.userInfo || {} : {};

    console.log(Existingcart, "ExistingcartItems");

    let NewCurrentItems = staticbody?.items;

    console.log("NewCurrentItems", NewCurrentItems);

    let finalCartItems = Existingcart?.items
      ? Existingcart?.items?.concat(NewCurrentItems)
      : NewCurrentItems;

    const uniqueCartItems = filterUniqueProducts(finalCartItems);
    let URL = JSON.stringify({
      items: uniqueCartItems,
      currency_code: currency_code,
      currency_symbol: currency_symbol,
      userInfo: userInfo,
    });

    let nextpageURL = encryptToBase64Url(URL);
    console.log(URL);
    // const urlToStore = `https://www.cubiclogics.com/checkout?producturl=${nextpageURL}`;

    //   const urlToStore = `https://www.cubiclogics.com/checkout`;
    //   HR365 Site
    // const urlToStore = `https://www.hr365.us/checkout`;
    //   APPS365 Site
    localStorage.setItem("storedUpdatedAppURL", nextpageURL);
    localStorage.setItem("storedActualAppURL", nextpageURL);
    let siteurl = ""
    if(SiteName == "HR365"){
      siteurl = "https://www.hr365.us/checkout/"
    }else{
      siteurl = "https://www.apps365.com/checkout/"
    }
    const urlToStore = `${siteurl}?producturl=${nextpageURL}`;
  


    window.open(urlToStore, "_self");
    console.log(urlToStore);
    // document.cookie = `appsproducturl=${nextpageURL}
    console.log(staticbody, "body");
  }

  return (
    // <div className="plans-container">
      <div id="pricing-widget-container" data-plan-type="Helpdesk 365">
        Loading Plans...
      </div>
    // </div>
  );
};

export default CustomPlans;
